// eslint-disable-next-line max-len
import { type FinderApplicationPrivateModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPrivateModuleSpecs';
// eslint-disable-next-line max-len
import { type FinderApplicationPublicModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPublicModuleSpecs';
import FinanceProductAssignments from './FinanceProductAssignments';
import FinderApplicationModuleConfiguration from './FinderApplicationModuleConfiguration';
import FinderApplicationModuleEmail from './FinderApplicationModuleEmail';
import FinderApplicationPrivateModuleConfiguration from './FinderApplicationPrivateModuleConfiguration';
import { HeaderTabs } from './type';
import VehicleAssignments from './VehicleAssignments';

type FinderApplicationModuleInnerPageProps = {
    activeTab: HeaderTabs;
    module: FinderApplicationPublicModuleSpecsFragment | FinderApplicationPrivateModuleSpecsFragment;
};

const FinderApplicationModuleInnerPage = ({ activeTab, module }: FinderApplicationModuleInnerPageProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails: {
            switch (module.__typename) {
                case 'FinderApplicationPublicModule':
                    return <FinderApplicationModuleConfiguration module={module} />;

                case 'FinderApplicationPrivateModule':
                    return <FinderApplicationPrivateModuleConfiguration module={module} />;

                default:
                    return null;
            }
        }

        case HeaderTabs.Vehicles:
            return <VehicleAssignments module={module} />;

        case HeaderTabs.FinanceProducts:
            return <FinanceProductAssignments module={module} />;

        case HeaderTabs.Email:
            return <FinderApplicationModuleEmail module={module} />;

        default:
            return null;
    }
};

export default FinderApplicationModuleInnerPage;
